import { FunctionComponent } from 'react';

import styles from './SubTitle.module.scss';

export type SubTitleProps = {
  subTitle: string | React.JSX.Element;
  center?: boolean;
  color?: string;
  fontSize?: string;
  lineHeight?: string;
  fontWeight?: string;
  variant?: 'regular' | 'bold' | 'small';
};

type FC = FunctionComponent<SubTitleProps>;

const SubTitle: FC = ({
  subTitle,
  center,
  fontWeight,
  variant = 'regular',
  fontSize,
  color = 'auto',
}: SubTitleProps) => {
  return (
    <h2
      className={[styles.subTitle, styles[variant], styles[getCenterClass()]].join(' ')}
      style={{ fontSize, fontWeight, color }}
    >
      {subTitle}
    </h2>
  );
  function getCenterClass() {
    return center ? 'center' : 'left';
  }
};

export default SubTitle;
